import React from 'react';
import './AboutUser.css';

function AboutUser({ isEditing, userData, setUserData }) {
  return (
    <div className="about-user-container">
      <span className="about-title">About Me</span>
      {isEditing ? (
        <textarea
          className="about-input"
          value={userData.aboutInstructor || ''}
          onChange={(e) => setUserData(prev => ({
            ...prev,
            aboutInstructor: e.target.value
          }))}
          rows="8"
        />
      ) : (
        <p className="user-about-paragraphy">
          {userData.aboutInstructor || 'No information provided'}
        </p>
      )}
    </div>
  );
}

export default AboutUser;